import { combineReducers } from 'redux';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
// import hardSet from 'redux-persist/lib/stateReconciler/hardSet';

import { reducer as toastrReducer } from 'react-redux-toastr';

import { authReducer } from './auth';
import { usersReducer } from './users';
import { stationsReducer } from './stations';
import { stationsDataReducer } from './stationsData';
import { stationsUsersGroupsReducer } from './stationsUsersGroups';
import { satellitesReducer } from './satellites';
import { logsReducer } from './logs';
import { preferencesReducer } from './preferences';

export default combineReducers({
  auth: persistReducer(
    {
      key: 'auth',
      storage,
      blacklist: ['error', 'loading'],
    },
    authReducer
  ),
  preferences: persistReducer(
    { key: 'preferences', storage },
    preferencesReducer
  ),
  logs: persistReducer(
    {
      key: 'logs',
      storage,
      blacklist: ['error', 'loading'],
    },
    logsReducer
  ),
  users: persistReducer(
    {
      key: 'users',
      storage,
      blacklist: ['error', 'loading'],
    },
    usersReducer
  ),
  stations: persistReducer(
    {
      key: 'stations',
      storage,
      blacklist: ['error', 'loading'],
      // stateReconciler: hardSet,
    },
    stationsReducer
  ),
  stationsData: persistReducer(
    {
      key: 'stationsData',
      storage,
      blacklist: ['error', 'loading'],
    },
    stationsDataReducer
  ),
  stationsUsersGroups: persistReducer(
    {
      key: 'stationsUsersGroups',
      storage,
      blacklist: ['error', 'loading'],
    },
    stationsUsersGroupsReducer
  ),
  satellites: persistReducer(
    {
      key: 'satellites',
      storage,
      blacklist: ['error', 'loading'],
    },
    satellitesReducer
  ),
  toastr: toastrReducer,
});
